namespace GeniuzPOS.InventoryReport {
    export interface IcReportEomForm {
        SkuCode: Serenity.StringEditor;
        SkuDesc: Serenity.StringEditor;
        QtyOnhand: Serenity.DecimalEditor;
        CostOnhand: Serenity.DecimalEditor;
        EndDate: Serenity.StringEditor;
        DtList: Serenity.StringEditor;
    }

    export class IcReportEomForm extends Serenity.PrefixedContext {
        static formKey = 'InventoryReport.IcReportEom';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!IcReportEomForm.init)  {
                IcReportEomForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DecimalEditor;

                Q.initFormType(IcReportEomForm, [
                    'SkuCode', w0,
                    'SkuDesc', w0,
                    'QtyOnhand', w1,
                    'CostOnhand', w1,
                    'EndDate', w0,
                    'DtList', w0
                ]);
            }
        }
    }
}
